import React, { PureComponent } from "react";

import { Select } from "../../common/Select";

export interface ISplitBySelector {
    value: string | undefined;
    keys: string[];
    onChange: (value: string | undefined) => void;
}

const label = (_: string | undefined) =>
    _ === undefined ? "All" : _ === "" ? "None" : _;

export class SplitBySelector extends PureComponent<ISplitBySelector> {
    public render() {
        const { value, keys, onChange } = this.props;

        if (keys.length === 0) {
            return false;
        }

        return (
            <Select
                value={value}
                options={[...(keys.length > 1 ? [undefined] : []), "", ...keys]}
                label={label}
                title="Split by"
                simple={true}
                right={true}
                onChange={onChange}
            />
        );
    }
}
